import configureStore from './configureStore';
import history from './utils/history';

const store = (() => {
  const initialState = {};
  return configureStore(initialState, history);
})();

export default store;
